import { render } from "./dimensionOption.vue?vue&type=template&id=4695935a&scoped=true"
import script from "./dimensionOption.vue?vue&type=script&lang=js"
export * from "./dimensionOption.vue?vue&type=script&lang=js"

import "./dimensionOption.vue?vue&type=style&index=0&id=4695935a&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4695935a"]])

export default __exports__